var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0404 13.1117C13.0161 13.175 13.007 14.0452 13.0203 15.0454L13.0444 16.8639H14.9542H16.8639V14.9542V13.0444L14.9742 13.0204C13.4906 13.0016 13.0751 13.0212 13.0404 13.1117ZM20.639 14.9542V16.9084H22.5488H24.4586V14.9542V13H22.5488H20.639V14.9542ZM28.1893 14.9542V16.9084H30.099H32.0088V14.9542V13H30.099H28.1893V14.9542ZM35.7799 13.1117C35.7556 13.175 35.7465 14.0452 35.7598 15.0454L35.7839 16.8639H37.6937H39.6034V14.9542V13.0444L37.7137 13.0204C36.2301 13.0016 35.8146 13.0212 35.7799 13.1117ZM13 22.5488V24.4586H14.9542H16.9084V22.5488V20.639H14.9542H13V22.5488ZM35.7395 22.5016V24.3641L30.7874 24.3891C25.9115 24.4138 25.8299 24.4171 25.4801 24.6054C25.0684 24.8269 24.813 25.0877 24.58 25.5245C24.4247 25.8156 24.4126 26.1508 24.3891 30.7874L24.3641 35.7395H22.5016H20.639V37.6937V39.6478H22.5044H24.3697L24.3703 44.4222C24.3705 47.3466 24.4054 49.3212 24.46 49.518C24.6494 50.1998 25.1992 50.7455 25.8818 50.9293C26.0962 50.987 29.9177 51.0104 36.7497 50.9957L47.287 50.9732L45.6078 48.0591C44.6843 46.4565 43.9056 45.1374 43.8776 45.1279C43.8495 45.1185 42.9045 46.0049 41.7775 47.0979C40.6507 48.1908 39.7102 49.0666 39.6877 49.0441C39.6653 49.0216 39.6571 45.6266 39.6695 41.4996L39.6923 33.9959L45.2883 37.2638C48.3661 39.0611 50.9153 40.5326 50.9529 40.5339C50.9907 40.5351 51.0107 37.2285 50.9973 33.1857C50.9733 25.8534 50.9727 25.8345 50.7819 25.4801C50.5604 25.0684 50.2996 24.813 49.8629 24.58C49.5718 24.4247 49.2365 24.4126 44.5999 24.3891L39.6478 24.3641V22.5016V20.639H37.6937H35.7395V22.5016ZM13 30.099V32.0088H14.9542H16.9084V30.099V28.1893H14.9542H13V30.099ZM13.0404 35.8511C13.0161 35.9145 13.007 36.7847 13.0203 37.7849L13.0444 39.6034H14.9542H16.8639V37.6937V35.7839L14.9742 35.7599C13.4906 35.7411 13.0751 35.7607 13.0404 35.8511ZM48.9479 42.6664C47.9807 42.949 47.1762 43.1948 47.1603 43.2127C47.1195 43.2586 50.7832 49.5922 50.8517 49.5945C50.9894 49.5991 51.0153 48.983 51.0163 45.6658C51.0175 42.3585 51.0077 42.1355 50.8621 42.1439C50.7767 42.1487 49.9153 42.3839 48.9479 42.6664Z",
    fill: "url(#paint0_linear_479_496)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_479_496",
    x1: 32.0082,
    y1: 13,
    x2: 32.0082,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB900B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d1a01083ca536835900210b2c2a8bb82.svg";
export { ForwardRef as ReactComponent };